export const SET_BOOKMARKS = "SET_BOOKMARKS";
export const SET_BOOKMARKS_REQUEST_LOADING = "SET_BOOKMARKS_REQUEST_LOADING";
export const SET_APP_LIST = "SET_APP_LIST";
export const SET_TOTAL_AUDIENCE = "SET_TOTAL_AUDIENCE";
export const SET_IS_TOTAL_CONTACTS_LOADING = "SET_IS_TOTAL_CONTACTS_LOADING";

export const SELECT_QLIK_APP = "SELECT_QLIK_APP";
export const RESET_CONFIG = "RESET_CONFIG";
